<template>
  <div class="authLoginPage">
    <template v-if="!loaded">
      <div class="loginErrorMsg">
        <img src="/static/failed.png" />
        <div class="errorText">{{errorText}}</div>
        <mu-flat-button label="退出登录" primary fullWidth class="refreshButton" @click="refreshLogin()"></mu-flat-button>
      </div>
    </template>    
    

    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import md5 from 'js-md5'
import UserCache from '../util/cache'
export default {
  data () {
    return {
      loaded:true,
      token:'',
      errorText:'',
    }
  },
  methods: {
    
  },
  mounted(){
    //this.$refs.XRtoast.load('加载中')
    //alert(window.location.href)

    this.token = this.$route.query.token
    if(!this.token){
      this.loaded = false
      this.errorText ='非法的请求'
      return;
    }    
    this.$store.dispatch('DelUser')
    this.$store.dispatch('SetUser', this.token)

    this.redirect()
  },
  methods: {
    refreshLogin(){
      this.$router.replace('/')
    },
    redirect(){      
      var redirect = this.$route.query.backurl              
      if(!redirect){
          redirect = '/'
      }
      this.$router.replace(redirect)
    },
  }
}
</script>
<style>
body .authLoginPage{
    background: #eee;
}

.authLoginPage .loginErrorMsg{
  overflow: hidden;
  text-align: center;
  padding: 80px 0 0;
}
.authLoginPage .loginErrorMsg img{
  width: 50%;  
}
.authLoginPage .loginErrorMsg .errorText{
  font-size: 18px;
  color:#333;
  padding: 20px 0 40px;
}
.authLoginPage .loginErrorMsg .refreshButton{
  width:60%;
  color:#E7C583;
  border: 1px solid #E7C583;
}
</style>




// WEBPACK FOOTER //
// src/pages/authLogin.vue